<template>
    <div class="zhaw-course-section">
        <b-card bg-variant="light" :img-src="courseIcon" img-alt="ZHAW Kurs-Icon" :img-height="imageHeight"
                :img-right="!isMobile">
            <b-card-title class="zhaw-course-title">
                {{ courseType }}
                {{ courseName }}
            </b-card-title>
            <b-card-text>
                <hr>
                <p v-if="courseDescription !== null">{{ courseDescription }}</p>
                <p v-if="courseStart !== null"><b>Start:</b> {{ courseStart }}</p>
                <p v-if="courseEcts !== null"><b>ECTS:</b> {{ courseEcts }}</p>
                <p v-if="recommendationScore !== null"><b>Empfehlung:</b>
                    <Score class="zhaw-details-panels-score" :score="recommendationScore" />
                </p>
                <div v-if="courseExplanations.length > 0">
                    <b>Begründung:</b>
                    <ul>
                        <li v-bind:key="explanation.index" v-for="explanation in courseExplanations">{{ explanation }}
                        </li>
                    </ul>
                </div>
                <a v-if="courseUrl !== null" :href="courseUrl" class="card-link" target="_blank">
                    <font-awesome-icon :icon="['fas', 'external-link-alt']" />
                    Zur Webseite
                </a>
            </b-card-text>
        </b-card>
    </div>
</template>

<script>
    import Score from "./Score";

    export default {
        name: "ResultDetails",
        components: {Score},
        props: {
            courseName: String,
            courseType: String,
            courseIcon: String,
            courseDescription: String,
            courseExplanations: Array,
            courseStart: String,
            courseEcts: Number,
            courseUrl: String,
            recommendationScore: Number
        },
        data() {
            return {
                windowWidth: window.innerWidth
            }
        },
        computed: {
            isMobile: function () {
                return this.windowWidth <= 768
            },
            imageHeight: function () {
                return this.isMobile ? '' : '100px'
            }
        }
    }
</script>

<style scoped>
    a {
        margin-left: 0 !important;
    }

    .zhaw-course-section {
        margin-bottom: 20px;
    }

    .zhaw-course-title {
        cursor: pointer;

        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }

    .zhaw-details-panels-score {
        padding-left: 5px;
    }
</style>